<div
	class="edit-item"
	[ngClass]="{ review: hasReviewableField, dim: isInactive, bordered: true }"
	[hidden]="hidden"
>
	@if(required){
	<div class="required">*{{ Loc(LocalizedTextIds.Required) }}</div>
	}
	<div
		class="edit-item-inner"
		[ngClass]="{ editable: isEditingThisProperty }"
	>
		<div class="flag-and-label-aligner">
			@if(showFlagIcon){
			<div class="flag-icon"></div>
			}
			<div class="alignBox">
				<div>
					<label
						class="label"
						for="{{ id }}"
						[ngClass]="propertyDecorationClass(true)"
					>
						{{ labelText }}
					</label>
				</div>
				<div class="labelDetail">{{ labelDetail }}</div>
			</div>
		</div>
		<div class="edit-item-inner-input-container" [formGroup]="parentForm">
			@if(type === EditItemType.Default){
			<input
				appTrim
				type="text"
				class="edit-item-inner-input"
				[ngClass]="propertyDecorationClass()"
				id="{{ id }}"
				maxlength="{{ maxLength }}"
				name="{{ id }}"
				formControlName="{{ propertyName }}"
				[readonly]="!isAvailableToEdit"
				(click)="makePropertyEditable($event)"
			/>
			@if(showLength && isEditingThisProperty){
			<div class="edit-item-length">
				{{ Loc(LocalizedTextIds.EditItemOf, currentLength, maxLength) }}
			</div>
			} } @if(isNumericType) { @if (!isEditingThisProperty){
			<div
				class="inline"
				[ngClass]="notEditingClass"
				[textContent]="numericValue"
				(click)="makePropertyEditable($event)"
			></div>
			}
			<div class="numeric-wrapper">
				<input
					appTrim
					type="number"
					class="edit-item-inner-input"
					[ngClass]="propertyDecorationClass()"
					id="{{ id }}"
					maxlength="{{ maxLength }}"
					max="{{ max }}"
					step="{{ step }}"
					name="{{ id }}"
					formControlName="{{ propertyName }}"
					(keydown.arrowup)="(false)"
					(keydown.arrowdown)="(false)"
					[readonly]="!isAvailableToEdit"
					[hidden]="!isEditingThisProperty"
					(click)="makePropertyEditable($event)"
				/>
			</div>
			@if(showLength && isEditingThisProperty) {
			<div class="edit-item-length">
				{{ Loc(LocalizedTextIds.EditItemOf, currentLength, maxLength) }}
			</div>
			} } @if(type === EditItemType.Multiline) {
			@if(!isEditingThisProperty){
			<div
				[ngClass]="notEditingClass"
				[textContent]="currentValue"
				(click)="makePropertyEditable($event)"
			></div>
			}
			<textarea
				appTrim
				[hidden]="!isEditingThisProperty"
				class="edit-item-inner-input-textarea"
				[ngClass]="{ 'jnj-confidential': isJnjConfidentialInfo }"
				id="{{ id }}"
				maxlength="{{ maxLength }}"
				name="{{ id }}"
				formControlName="{{ propertyName }}"
				(click)="makePropertyEditable($event)"
			></textarea>
			@if(showLength && isEditingThisProperty){
			<div class="edit-item-length">
				{{ Loc(LocalizedTextIds.EditItemOf, currentLength, maxLength) }}
			</div>
			} } @else if(type === EditItemType.ConstrainedValue) { @if(prompt){
			<div
				class="prompt"
				[ngClass]="{ 'jnj-confidential': isJnjConfidentialInfo }"
			>
				{{ prompt }}
			</div>
			} @if(!isEditingThisProperty){
			<div
				[ngClass]="notEditingClass"
				[textContent]="selectedChoiceVal"
				(click)="makePropertyEditable($event)"
			></div>
			} @if(valueList && isEditingThisProperty){
			<div class="select">
				<select
					class="select-control"
					id="{{ id }}"
					name="{{ id }}"
					formControlName="{{ propertyName }}"
					(click)="stopEventPropagationDuringEditing($event)"
					(change)="onConstrainedValueChange($event.target)"
				>
					@for(item of valueList; track item){
					<option [ngValue]="item.value">
						{{ Loc(item.label ?? item.value) }}
					</option>
					}
				</select>
			</div>
			} } @else if(type === EditItemType.MultiChoice){

			<div
				[ngClass]="{ readonly: !isAvailableToEdit }"
				(click)="makePropertyEditable($event)"
			>
				@if(prompt){
				<div
					class="prompt"
					[ngClass]="{
							'jnj-confidential': isJnjConfidentialInfo,
							'with-tooltip': hasTooltip,
						}"
				>
					<div
						class="info-icon"
						(mouseenter)="toggleTooltip()"
						(mouseleave)="toggleTooltip()"
					>
						@if(isShowingTooltip) {
						<div class="tooltip">
							{{ tooltip }}
						</div>
						}
					</div>
					{{ prompt }}
				</div>
				}
				<div class="multi-choice">
					@for(item of valueList; track item.value){
					<div
						class="edit-item-checkbox"
						[ngClass]="{ editable: isEditingThisProperty }"
					>
						<input
							type="checkbox"
							class="tick"
							[ngClass]="{
										editable: isEditingThisProperty,
										different: isThisUpdateFieldSet,
									}"
							id="company-update-company-{{ propertyName }}-{{
								item.value
							}}"
							name="company-update-company-{{ propertyName }}-{{
								item.value
							}}"
							[value]="item.value"
							[checked]="isCheckedMultiChoice(item.value)"
							(click)="
								stopEventPropagationDuringEditing($event, true)
							"
							(change)="onMultiChoiceItemChange(item.value)"
						/>
						<div
							class="label"
							[ngClass]="{
										review: isReviewMode,
										strikethrough: isPropertyDeclined,
										editable: isEditingThisProperty,
										different: isThisUpdateFieldSet,
									}"
						>
							{{ Loc(item.label ?? item.value) }}
						</div>
					</div>
					}
				</div>
				@if(showFootnote) {
				<div class="footnote">
					{{ footnote }}
				</div>
				}
			</div>
			} @else if(type === EditItemType.MultiModal){

			<div
				class="edit-item-inner-items-container"
				(click)="stopEventPropagationDuringEditing($event)"
			>
				<multi-picker-modal
					[options]="valuesAsStrings"
					[itemType]="propertyName"
					[blurb]="prompt"
					[showModal]="showMultiPickerModal"
					(action)="addItems($event)"
				>
				</multi-picker-modal>

				@if(isAvailableToEdit) {
				<div
					class="edit-item-inner-items-pill-area"
					[ngClass]="{
								'not-for-review':
									isReviewMode && !isReviewableUpdateFieldSet,
							}"
				>
					@for(item of currentArrValue; track item){
					<div
						class="edit-item-inner-items-pill"
						(click)="makePropertyEditable($event)"
					>
						<div class="edit-item-inner-items-pill-label">
							{{ item }}
						</div>
						@if(isEditingThisProperty){
						<img
							class="edit-item-inner-items-pill-icon"
							src="/assets/update/close.svg"
							(click)="removeItem(item, $event)"
						/>}
					</div>
					} @if(isEditingThisProperty){
					<div
						class="edit-item-inner-items-add-pill"
						(click)="launchMultiPickerModal($event)"
					>
						<img
							class="edit-item-inner-items-add-icon"
							src="/assets/update/add-items.svg"
						/>
						<div class="edit-item-inner-items-add-pill-label">
							{{ addText }}
						</div>
					</div>
					}
				</div>
				} @else {

				<div class="items-review-details">
					@if(itemsUnchanged.length > 0){
					<div class="items-unchanged">
						<div class="title">
							{{ Loc(LocalizedTextIds.Unchanged) }}
						</div>
						<div class="edit-item-inner-items-pill-area-wrapper">
							<div class="edit-item-inner-items-pill-area">
								@for(item of itemsUnchanged; track item) {
								<div
									class="edit-item-inner-items-pill unchanged"
								>
									<div
										class="edit-item-inner-items-pill-label"
									>
										{{ item }}
									</div>
								</div>
								}
							</div>
						</div>
					</div>
					} @if(itemsRemoved.length){
					<div class="items">
						<div class="title">
							{{ Loc(LocalizedTextIds.Removed) }}
						</div>
						<div class="subtitle">
							<localized-text-snippet text="{{ removeText }}">
							</localized-text-snippet>
						</div>
						<div class="edit-item-inner-items-pill-area-wrapper">
							<div class="edit-item-inner-items-pill-area">
								@for(item of itemsRemoved; track item){
								<div
									class="edit-item-inner-items-pill removed"
									[ngClass]="{
												preserved:
													isPreservedItem(item),
											}"
								>
									<div
										class="edit-item-inner-items-pill-label removed"
										[ngClass]="{
													preserved:
														isPreservedItem(item),
												}"
									>
										{{ item }}
									</div>
									<img
										class="edit-item-inner-items-pill-icon removed"
										src="/assets/update/ic-settings-backup-restore-24px.svg"
										(click)="
											toggleItemPreservation(item, $event)
										"
									/>
								</div>
								}
							</div>
						</div>
					</div>
					} @if(itemsAdded.length){
					<div class="items">
						<div class="title">
							{{ Loc(LocalizedTextIds.Added) }}
						</div>
						<div class="subtitle">
							<localized-text-snippet text="{{ addedText }}">
							</localized-text-snippet>
						</div>
						<div class="edit-item-inner-items-pill-area-wrapper">
							<div class="edit-item-inner-items-pill-area">
								@for(item of itemsAdded; track item){
								<div
									class="edit-item-inner-items-pill"
									[ngClass]="{
												excluded: isExcludedItem(item),
											}"
								>
									<div
										class="edit-item-inner-items-pill-label"
										[ngClass]="{
													excluded:
														isExcludedItem(item),
												}"
									>
										{{ item }}
									</div>
									<img
										class="edit-item-inner-items-pill-icon"
										src="/assets/update/close.svg"
										(click)="
											toggleItemExclusion(item, $event)
										"
									/>
								</div>
								}
							</div>
						</div>
					</div>
					}
				</div>
				}
			</div>
			@if(isEditingThisProperty && isEditMode) {
			<div class="edit-item-inner-items-subtitle">
				{{ subtitle }}
			</div>
			} } @else if(type === EditItemType.Logo){
			<div class="edit-item-inner-logo-container">
				<input
					type="file"
					#logoBase64chooser
					(change)="onLogoUpdated($event)"
					accept="image/*"
					style="display: none"
					(click)="$event.stopPropagation()"
				/>
				<company-logo
					[logoBase64]="company.logoBase64"
					[size]="logoSize"
					(click)="makePropertyEditable($event)"
					show="true"
				></company-logo>
				@if(isEditingThisProperty){
				<div class="blurb-and-button">
					<span class="blurb">{{
						Loc(
							LocalizedTextIds.EditItemYourLogo,
							bytesToHumanReadableDisplayString(
								maxUploadLogoImageSize
							)
						)
					}}</span>
					<div class="button" (click)="launchLogoChooser($event)">
						<img src="/assets/update/ic-file-upload-24px.svg" />
						<div class="label">
							{{ Loc(LocalizedTextIds.EditItemChoose) }}
						</div>
					</div>
					<div class="validation-errors">
						@if(badLogoType){
						<div>
							{{ Loc(LocalizedTextIds.EditItemOnlyJPG) }}
						</div>
						} @if (logoTooLarge){
						<div>
							{{
								Loc(
									LocalizedTextIds.EditItemLogoImage,
									maxUploadLogoImageSize
								)
							}}
						</div>
						}
					</div>
				</div>
				}
			</div>
			}
			<ng-container *ngTemplateOutlet="viewOriginal"></ng-container>
			@if(isAvailableToEdit){
			<div
				class="edit-button"
				name="edit-button"
				[ngClass]="{ dim: isEditingThisProperty }"
				(click)="makePropertyEditable($event)"
			>
				@if(showRevertIcon){
				<img
					src="/assets/update/undo-circle-2.svg"
					class="revert-icon"
					(click)="revertEdit($event)"
				/>
				} +{{ Loc(LocalizedTextIds.Edit) }}
			</div>
			}
		</div>
	</div>
	@if(isReadOnly) {
	<div
		class="read-only"
		[ngClass]="{ 'jnj-confidential': isJnjConfidentialInfo }"
	>
		<div>{{ subtitle }}</div>
	</div>
	}
	<ng-template #viewOriginal>
		@if(showViewOriginalButton) {
		<div
			class="view-original-outer"
			[ngClass]="{ 'jnj-confidential': isJnjConfidentialInfo }"
		>
			<div class="view-original-inner">
				<div
					class="view-original"
					(click)="isShowingOriginalText = !isShowingOriginalText"
				>
					<img
						src="/assets/update/arrow-down-1.svg"
						[ngClass]="{
							'arrow-closed': !isShowingOriginalText,
							'arrow-opened': isShowingOriginalText,
						}"
					/>
					<div class="text">
						{{ showOrHideOriginalText }}
					</div>
				</div>
			</div>
			@if(isShowingOriginalText) {
			<div
				class="original"
				[ngClass]="{ 'jnj-confidential': isJnjConfidentialInfo }"
			>
				<div class="text">{{ originalValueDisplay }}</div>
			</div>
			}
		</div>
		}
	</ng-template>
</div>
@if(showApproveDecline){
<approve-decline
	[includeInSummary]="isThisUpdateFieldSet"
	[propertyName]="propertyName"
>
</approve-decline>
}
